import { CheckCheck, SendHorizonalIcon, ShieldCheck, Trash2 } from 'lucide-react';
import moment from 'moment';
import React from 'react';
import { useSocket } from '../Context/SocketContext';
import { infoUser } from '../utils/auth';

const TalkTypeValidByUser = ({ m, deleteMessage, init, setNotifTalk, type = "stream" }) => {
    const userToken = infoUser()
    const { projectJson, socket, socketSport } = useSocket()
    const matchSocket = type == "stream" ? socket : socketSport

    const validPaiement = () => {
        if (m.user_id && userToken.expecttoken && m.id) {
            matchSocket.emit('empire_valid_paiement', {
                token: userToken.expecttoken,
                idUser: parseInt(m.user_id),
                nameAdmin: userToken.name,
                idAskPaiement: m.id
            }, (e) => {
                setNotifTalk && setNotifTalk({ txt: `Paiement validé`, c: "bcs cb" })
                init && init()
            })
        }
    }
    const validPaiementByEmail = () => {
        if (m.email && userToken.expecttoken && m.id) {
            matchSocket.emit('empire_valid_paiement_by_email', {
                token: userToken.expecttoken,
                email: m.email,
                nameAdmin: userToken.name,
                idAskPaiement: m.id
            }, (e) => {
                setNotifTalk && setNotifTalk({ txt: `Paiement validé (email)`, c: "bcs cb" })
                init && init()
            })
        }
    }
    const refusePaiement = () => {
        if (m.user_id && userToken.expecttoken && m.id) {
            matchSocket.emit('empire_refuse_paiement', {
                token: userToken.expecttoken,
                idUser: parseInt(m.user_id),
                nameAdmin: userToken.name,
                idAskPaiement: m.id
            }, (e) => {
                setNotifTalk && setNotifTalk({ txt: `Paiement refusé`, c: "bce cww" })
                init && init()
            })
        }
    }

    return (
        <div className='df fdc aic jcc w100 bcw py2 px1' style={{ borderRadius: "10px" }}>
            <div className='df aic jcsb w100'>
                <div className='df aic gap1'>
                    <div className='c-avatar'>
                        {m.role == "user" && type == "stream" && (
                            <img className='avatar' src={projectJson?.href + "/images/users/" + m.path}></img>
                        )}
                    </div>
                    <div className='df fdc'>
                        <div className='df gap1 aic'>
                            <SendHorizonalIcon color={'#0074dc'} size={20} />
                            <p style={{ fontSize: "0.8em" }} className='fr cb tal'>{moment(m.date).fromNow()}</p>
                        </div>
                        {m.status == "Lu" && (
                            <div className='df gap1 aic'>
                                <CheckCheck color={'#0074dc'} size={20} />
                                <p style={{ fontSize: "0.8em" }} className='fr cb tal'>{moment(m.date_read).fromNow()}</p>
                            </div>
                        )}
                    </div>
                </div>

                <div>
                    <button onClick={deleteMessage}><Trash2 color='#f71717' size={20} /></button>
                </div>
            </div>

            <ShieldCheck color={'#9754e3'} size={28} className='mt1' />
            <p className='fb cb fs1 tac py1'>L'utilisateur déclare avoir payé</p>
            <p className='fr cgrey tac '>Vérifiez le paiement puis validez ou refusez l'action</p>
            <div className='df gap1 mt2 fw jcc'>
                <button onClick={validPaiement} className='px2 cp bcs cw fr br10 py1'>Valider</button>
                <button onClick={validPaiementByEmail} className='px2 cp bcs2 cw fr br10 py1'>Valider par email</button>
                <button onClick={refusePaiement} className='px2 cp bce cw fr br10 py1'>Refuser</button>
            </div>
        </div>
    );
};

export default TalkTypeValidByUser;
